export default {
  zh: {
    map: {
      title: '地震预测地图',
      legend: {
        predict: '预测点',
        actual: '实际点',
        over15: '预测失败',
        within15: '正在监测中',
        line: '预测-实际连线'
      },
      controls: {
        zoomIn: '放大地图',
        zoomOut: '缩小地图',
        locate: '回到当前位置',
        showPlate: '显示区域',
        hidePlate: '隐藏区域'
      },
      filter: {
        '1y': '一年',
        '6m': '半年',
        '3m': '三个月',
        '1m': '一个月',
        flash: '当前预测',
      },
      stats: {
        total: '总预测数',
        success: '预测成功',
        flash: '正在监测中',
        fail: '预测失败',
        note: '说明：预测成功是指 15天 内已发生且相距不超过 300 公里',
        history: '历史记录',
        refreshPlate: '刷新区域'
      },
      info: {
        predictTitle: '预测信息',
        actualTitle: '实际信息',
        predMag: '预测震级(M)：',
        predTime: '预测时间：',
        predRemark: '预测说明：',
        actStartdate: '发生时间：',
        actMag: '实际震级(M)：',
        actInterval: '相差时间：',
        actDistance: '相隔距离：',
        happened: '已发生',
        notHappened: '未发生',
        notHappenedWithin15: '15天内未发生',
        over15: '已超15天'
      },
      history: {
        title: '地震历史记录',
        detail: '详情',
        no: '预测序号',
        predLat: '预测纬度(°)',
        predLng: '预测经度(°)',
        plName: '区域名称',
        predMag: '预测震级(M)',
        predOpname: '预测发布人',
        predDate: '预测发布时间',
        actHappen: '是否发生',
        actStartdate: '发生时间',
        actLat: '实际纬度(°)',
        actLng: '实际经度(°)',
        actMag: '实际震级(M)',
        dayOffset: '间隔天数(天)',
        distance: '距离(km)',
        actOpname: '结果发布人',
        actDatasource: '数据来源',
        operation: '操作',
        informationMode: '信息方式',
        predInfosourceMacro: '宏观',
        predInfosourceMicro: '微观',
        actFocalDepth: '震源深度',
        actFocalDepthKm: '震源深度(km)',
        actRemark: '发布说明',
      },
      detail: {
        title: '详情',
        predSection: '预测信息',
        actSection: '实际信息',
        predNum: '预测序号',
        predCoord: '预测坐标',
        predDate: '预测发布时间',
        predMag: '预测震级(M)',
        plName: '区域名称',
        predOpname: '预测发布人',
        actHappen: '是否发生',
        actCoord: '实际坐标',
        actStartdate: '发生时间',
        actMag: '实际震级(M)',
        actDate: '结果发布时间',
        dayOffset: '间隔天数',
        distance: '相隔距离',
        actOpname: '结果发布人',
        actDatasource: '数据来源',
        close: '关 闭',
        locate: '定位到地图',
        coordLabel: '经纬度(°)',
        day: '天',
        km: 'km',
        informationMode: '信息方式',
        predInfosourceMacro: '宏观',
        predInfosourceMicro: '微观',
        actFocalDepth: '震源深度',
        actFocalDepthKm: '震源深度(km)',
        actRemark: '发布说明',
        prev: '上一条',
        next: '下一条',
      },
      msg: {
        loadMapFail: '加载地图数据失败',
        plateRefreshed: '区域数据已刷新',
        mapNotReady: '地图尚未加载完成，请稍后重试',
        gettingLocation: '正在获取当前位置...',
        backToLocation: '已回到当前位置',
        gpsFailIp: 'GPS定位失败，尝试IP定位...',
        ipSuccess: 'IP定位成功',
        locateFail: '定位失败，请检查网络或手动选择位置',
        distanceTip: '预测点与实际点距离：{d} km',
        loadDataFail: '加载数据失败，请稍后重试',
        mapNotReadyShort: '地图未准备就绪',
        invalidCoord: '坐标无效',
        located: '已定位到地图',
        plateShown: '已显示区域',
        plateHidden: '已隐藏区域',
        scriptNotLoaded: '地图脚本加载失败，请检查网络或 AK 配置',
      }
    }
  },
  en: {
    map: {
      title: 'Earthquake Prediction Map',
      legend: {
        predict: 'Prediction',
        actual: 'Actual',
        over15: 'Failed',
        within15: 'Under Monitoring',
        line: 'Prediction-Actual line'
      },
      controls: {
        zoomIn: 'Zoom in',
        zoomOut: 'Zoom out',
        locate: 'Back to current location',
        showPlate: 'Show regions',
        hidePlate: 'Hide regions'
      },
      filter: {
        '1y': '1 Year',
        '6m': '6 Months',
        '3m': '3 Months',
        '1m': '1 Month',
        flash: 'Active',
      },
      stats: {
        total: 'Total Predictions',
        success: 'Success',
        flash: 'Under Monitoring',
        fail: 'Failed',
        note: 'Note: "Success" means an earthquake occurred within 15 days and within 300 km.',
        history: 'History',
        refreshPlate: 'Refresh Regions'
      },
      info: {
        predictTitle: 'Prediction Info',
        actualTitle: 'Actual Info',
        predMag: 'Predicted Mag (M): ',
        predTime: 'Predicted Time: ',
        predRemark: 'Note: ',
        actStartdate: 'Occurred Time: ',
        actMag: 'Actual Mag (M): ',
        actInterval: 'Interval: ',
        actDistance: 'Distance: ',
        happened: 'Occurred',
        notHappened: 'Not Occurred',
        notHappenedWithin15: 'Not occurred within 15 days',
        over15: 'Over 15 days'
      },
      history: {
        title: 'Earthquake History',
        detail: 'Detail',
        no: 'Pred. No.',
        predLat: 'Pred. Lat (°)',
        predLng: 'Pred. Lng (°)',
        plName: 'Region',
        predMag: 'Pred. Mag (M)',
        predOpname: 'Pred. Publisher',
        predDate: 'Publish Time',
        actHappen: 'Occurred',
        actStartdate: 'Occurred Time',
        actLat: 'Actual Lat (°)',
        actLng: 'Actual Lng (°)',
        actMag: 'Actual Mag (M)',
        dayOffset: 'Interval (days)',
        distance: 'Distance (km)',
        actOpname: 'Result Publisher',
        actDatasource: 'Data Source',
        operation: 'Actions',
        informationMode: 'Information Mode',
        predInfosourceMacro: 'Macro',
        predInfosourceMicro: 'Micro',
        actFocalDepth: 'Focal Depth',
        actFocalDepthKm: 'Focal Depth (km)',
        actRemark: 'Publish Note'
      },
      detail: {
        title: 'Details',
        predSection: 'Prediction Info',
        actSection: 'Actual Info',
        predNum: 'Pred. No.',
        predCoord: 'Prediction Coord.',
        predDate: 'Publish Time',
        predMag: 'Predicted Mag (M)',
        plName: 'Region',
        predOpname: 'Pred. Publisher',
        actHappen: 'Occurred',
        actCoord: 'Actual Coord.',
        actStartdate: 'Occurred Time',
        actMag: 'Actual Mag (M)',
        actDate: 'Result Publish Time',
        dayOffset: 'Interval',
        distance: 'Distance',
        actOpname: 'Result Publisher',
        actDatasource: 'Data Source',
        close: 'Close',
        locate: 'Locate on Map',
        coordLabel: 'Lat/Lng (°)',
        day: 'day(s)',
        km: 'km',
        informationMode: 'Information Mode',
        predInfosourceMacro: 'Macro',
        predInfosourceMicro: 'Micro',
        actFocalDepth: 'Focal Depth',
        actFocalDepthKm: 'Focal Depth (km)',
        actRemark: 'Publish Note',
        prev: 'Previous',
        next: 'Next',
      },
      msg: {
        loadMapFail: 'Failed to load map data',
        plateRefreshed: 'Region data refreshed',
        mapNotReady: 'Map is not ready, please try again later',
        gettingLocation: 'Getting current location...',
        backToLocation: 'Back to your location',
        gpsFailIp: 'GPS failed, trying IP location...',
        ipSuccess: 'IP location succeeded',
        locateFail: 'Location failed, please check network or pick manually',
        distanceTip: 'Distance between prediction and actual: {d} km',
        loadDataFail: 'Failed to load data, please try again later',
        mapNotReadyShort: 'Map is not ready',
        invalidCoord: 'Invalid coordinate',
        located: 'Located on map',
        plateShown: 'Regions shown',
        plateHidden: 'Regions hidden',
        scriptNotLoaded: 'Failed to load map script, please check network or AK config',
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/modules/map.js